import { UserInfo } from './UserInfo';
import { Customer } from './Customer';

class DashboardData {
  userInfo: UserInfo;
  customers: Customer[];

  constructor(userInfo: UserInfo, customers: Customer[]) {
    this.userInfo = userInfo;
    this.customers = customers;
  }
}

export { DashboardData };
